import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { SHOW_CRUISE_AD } from '../config';

interface AppSettings {
  showCruiseAd: boolean;
}

interface AppSettingsContextType {
  settings: AppSettings | null;
  loading: boolean;
}

const AppSettingsContext = createContext<AppSettingsContextType | null>(null);

export const useAppSettings = () => {
  const context = useContext(AppSettingsContext);
  if (!context) {
    throw new Error('useAppSettings must be used within an AppSettingsProvider');
  }
  return context;
};

interface AppSettingsProviderProps {
  children: ReactNode;
}

export const AppSettingsProvider = ({ children }: AppSettingsProviderProps) => {
  const [settings, setSettings] = useState<AppSettings | null>(null);
  const [loading, setLoading] = useState(true);
  useAuth(); // Keep AuthContext in tree; no fields needed here

  useEffect(() => {
    // Settings are sourced from a compile-time constant — no network call needed.
    // Empty deps so this runs once on mount, not on every auth state change.
    setSettings({
      showCruiseAd: SHOW_CRUISE_AD
    });
    setLoading(false);
  }, []);

  return (
    <AppSettingsContext.Provider value={{ settings, loading }}>
      {children}
    </AppSettingsContext.Provider>
  );
};